module.exports = __webpack_public_path__ + "static/img/logo11.8e917216.png";